import { render, staticRenderFns } from "./WhiteLayout.vue?vue&type=template&id=4b6da96e&scoped=true&"
import script from "./WhiteLayout.vue?vue&type=script&lang=js&"
export * from "./WhiteLayout.vue?vue&type=script&lang=js&"
import style0 from "./WhiteLayout.vue?vue&type=style&index=0&id=4b6da96e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6da96e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
